import { observer } from 'mobx-react';
import { GameBadgeBox } from '../../boxes/game-badge/game-badge.box';
import { GameBadgeFlipperWrapper } from '../../boxes/game-badge-flipper/game-badge-flipper-wrapper.box';
import { GameBadgeFlippeInner } from '../../boxes/game-badge-flipper/game-badge-flipper-inner.box';
import { GameBadgeFlipperFront } from '../../boxes/game-badge-flipper/game-badge-flipper-front.box';
import { GameBadgeFlipperBack } from '../../boxes/game-badge-flipper/game-badge-flipper-back.box';
import { Image } from '../../../../raw-components/image/image';

export interface GameBadgeFliperComponentProps {
    badgeUrl?: string;
    flipBadgeUrl?: string;
    useSquareIcons?: boolean;
}


export const GameBadgeFliperComponent: React.FC<GameBadgeFliperComponentProps> = observer((props) => {
    if (!props.badgeUrl && !props.flipBadgeUrl) {
        return null
    }

    if (!props.flipBadgeUrl) {
        return (<GameBadgeBox lazy src={props.badgeUrl} useSquareIcons={props.useSquareIcons} className='cy-game-badge' />)
    }

    if (!props.badgeUrl) {
        return (<GameBadgeBox lazy src={props.flipBadgeUrl} useSquareIcons={props.useSquareIcons} className='cy-game-badge' />)
    }

    return (
        <GameBadgeFlipperWrapper useSquareIcons={props.useSquareIcons}>
            <GameBadgeFlippeInner>
                <GameBadgeFlipperFront>
                    <Image lazy src={props.badgeUrl} className='cy-game-badge' />
                </GameBadgeFlipperFront>
                <GameBadgeFlipperBack>
                    <Image lazy src={props.flipBadgeUrl} className='cy-game-badge' />
                </GameBadgeFlipperBack>
            </GameBadgeFlippeInner>
        </GameBadgeFlipperWrapper>
    )
});